export const SET_CURRENT_TAB_INDEX = 'SET_CURRENT_TAB_INDEX';
export const SET_PMREQAESERV_PROJ_ID = 'SET_PMREQAESERV_PROJ_ID';
export const SET_AELOOKAESERV_PROJ_ID = 'SET_AELOOKAESERV_PROJ_ID';
export const FETCH_lkp_QueueType_AE_FULFILLED = 'FETCH_lkp_QueueType_AE_FULFILLED';
export const FETCH_lkp_StatusTracking_AE_FULFILLED = 'FETCH_lkp_StatusTracking_AE_FULFILLED';
export const FETCH_lkp_Phase_AE_FULFILLED = 'FETCH_lkp_Phase_AE_FULFILLED';
export const FETCH_lkp_ProjectProgramType = 'FETCH_lkp_ProjectProgramType';
export const FETCH_lkp_ProjectType = 'FETCH_lkp_ProjectType';
export const FETCH_lkp_ProjectTypeForPb = 'FETCH_lkp_ProjectTypeForPb';
export const FETCH_ProjectType = 'FETCH_ProjectType';
export const POST_PROJECT_TYPES = 'POST_PROJECT_TYPES';
export const FETCH_AE_SEARCH_RESULTS = 'FETCH_AE_SEARCH_RESULTS';
export const FETCH_AE_SEARCH_RESULTS_FAILED = 'FETCH_AE_SEARCH_RESULTS_FAILED';
export const POST_AE_TRACKING = 'POST_AE_TRACKING';
export const FETCH_DELAYS_GAINS = 'FETCH_DELAYS_GAINS';
export const FETCH_DELAY_PHASE_OF_OCCURRENCE = 'FETCH_DELAY_PHASE_OF_OCCURRENCE';
export const FETCH_DELAY_CATEGORY = 'FETCH_DELAY_CATEGORY';
export const FETCH_DELAY_SUBCATEGORY = 'FETCH_DELAY_SUBCATEGORY';
export const FETCH_DELAY_ATTTRIBUTED_TOS = 'FETCH_DELAY_ATTTRIBUTED_TO';
export const FETCH_lkp_Complexity = 'FETCH_lkp_Complexity';
export const FETCH_lkp_LeedCertification = 'FETCH_lkp_LeedCertification';
export const FETCH_ComplexityAnswers = 'FETCH_ComplexityAnswers';
export const POST_ComplexityAnswers = 'POST_ComplexityAnswers';
